module.exports = __webpack_public_path__ + "img/icon-vote.26d0fa23.svg";